import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  Routes,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';

import {
  WEB_PLATFORM_ENVIRONMENT,
  WEB_PLATFORM_IS_BUILD_MODE,
  WEB_PLATFORM_VERSION,
} from 'shared/infra/constants/platform.const';

// 'true' when production mode (build), not in dev mode (start/local, test)
// Default value false (review the other file config-overrides.js)
const ENABLED_LOCAL: boolean = false;

Sentry.init({
  enabled: WEB_PLATFORM_IS_BUILD_MODE || ENABLED_LOCAL,
  environment: WEB_PLATFORM_ENVIRONMENT,
  release: `${process.env.REACT_APP_SENTRY_PROJECT}@${WEB_PLATFORM_VERSION}`,
  dsn: process.env.REACT_APP_SENTRY_INIT_DSN,
  debug: false,
  maxBreadcrumbs: 50,
  sendClientReports: false,
  integrations: [
    // Sentry.browserTracingIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing.
  // To build production use a lower value like '0.1'
  tracesSampleRate: 0.1,
  tracePropagationTargets: [
    /^https:\/\/aliados\.rappi\.com/,
    /^https:\/\/aliados.*\.dev\.rappi\.com/,
    /^https:\/\/lite.*\.dev\.rappi\.com/,
    ...((): string[] => (ENABLED_LOCAL ? ['localhost'] : []))(),
  ],
});

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
